import React from 'react';
import { useTranslate } from '../../contexts/languageContext';
import EstadisticasConsolidadoTablaCabecera from './EstadisticasConsolidadoTablaCabecera';
import EstadisticasConsolidadoTablaFilaCampo from './EstadisticasConsolidadoTablaFilaCampo';
import styled from 'styled-components/macro';

const EstadisticasConsolidadoTabla = props => {
  const t = useTranslate();
  return (
    <TablaEstadisticas>
      <table>
        <tbody>
          <EstadisticasConsolidadoTablaFilaCampo
            title={t('votos')}
            data={props.data.data[0].vot}
            fmt={true}
          />
          <EstadisticasConsolidadoTablaFilaCampo
            title={t('porcentaje')}
            data={props.data.data[0].pvot}
          />
        </tbody>
      </table>
    </TablaEstadisticas>
  );
};

const TablaEstadisticas = styled.section`
  width:95%;
  background-color: white;
`;

export default EstadisticasConsolidadoTabla;
